
import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface UrgencyNoticeProps {
  message: string;
}

const UrgencyNotice = ({ message }: UrgencyNoticeProps) => {
  if (!message) return null;
  
  return (
    <Alert variant="destructive" className="bg-amber-50 border-amber-200 text-amber-800 mb-3">
      <AlertTriangle className="h-4 w-4 text-amber-600" />
      <AlertDescription className="text-sm font-medium">
        {message}
      </AlertDescription>
    </Alert>
  );
};

export default UrgencyNotice;
